/**
 * A chord symbol, set properly.
 *
 * ## Why this is not just a `<span>` with a font on it
 *
 * `♭`, `♯` and `♮` are U+266D–U+266F, and essentially no text serif contains them — so
 * every browser substitutes them from a fallback font, and fallback substitution brings
 * the fallback's side bearings with it. The result is that "A♭maj7" renders as
 * "A ♭ maj7", which at 32px reads as three words. Negative tracking on the whole symbol
 * cramps the letters to fix a problem the letters do not have.
 *
 * So the accidentals are wrapped and tightened individually. It is a small thing that is
 * visible in every chord with a black note in it, which is most of them.
 */

const ACCIDENTALS = new Set(['♭', '♯', '♮', '𝄫', '𝄪']);

export function ChordSymbol({ symbol }: { symbol: string }): React.JSX.Element {
  return (
    <>
      {[...symbol].map((glyph, index) =>
        ACCIDENTALS.has(glyph) ? (
          <span key={index} className="hc-accidental">
            {glyph}
          </span>
        ) : (
          glyph
        ),
      )}
    </>
  );
}
